export default __webpack_public_path__ + "static/media/img-13.1416fc05.png";